"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebReviewsRouter = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const web_review_schema_1 = require("./web.review.schema");
const c = (0, core_1.initContract)();
exports.WebReviewsRouter = c.router({
    create: {
        method: 'POST',
        path: '/create',
        body: web_review_schema_1.WebContractCreateReviewRequestSchema,
        responses: { 201: (0, shared_1.createSuccessResponseSchema)(zod_1.z.undefined()) },
    },
    update: {
        method: 'POST',
        path: '/:reviewId/update',
        pathParams: web_review_schema_1.WebContractReviewIdPathParamsSchema,
        body: web_review_schema_1.WebContractUpdateReviewRequestSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(zod_1.z.undefined()) },
    },
    get: {
        method: 'GET',
        path: '/:reviewId',
        pathParams: web_review_schema_1.WebContractReviewIdPathParamsSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_review_schema_1.WebContractGetReviewResponseSchema) },
    },
    list: {
        method: 'GET',
        path: '/',
        query: web_review_schema_1.WebContractReviewQueryParamsSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_review_schema_1.WebContractListReviewsResponseSchema) },
    },
}, { pathPrefix: '/reviews' });
